var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"partner-box"},[_c('div',{staticClass:"partner-title"},[_vm._v("服务的客户")]),_c('div',{staticClass:"partner-item-box"},_vm._l((12),function(item){return _c('div',{key:item,staticClass:"partner-item"},[_c('img',{attrs:{"src":require(`@/assets/website/service/partner${item}.png`),"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }